import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ProductForm from "./ProductForm";
import { GetsingleProduct, EditProduct } from "../api";

function EditProductPage() {
  const { slug } = useParams();

  const [product, setProduct] = useState(null);

  useEffect(() => {
    const getProduct = async () => {
      try {
        const res = await GetsingleProduct(slug);
        console.log(res, "resresresresres");
        if (res.data.success) {
          setProduct(res.data.product);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getProduct();
  }, [slug]);
  const updateProduct = async (data) => {
    try {
      console.log("SUBMIT DATA =>", data);

      const res = await EditProduct(slug, data);

      console.log("UPDATE RESPONSE =>", res.data);

      if (res.data.success) {
        alert("Product Updated Successfully");
      }
    } catch (error) {
      console.log("ERROR =>", error.response?.data);
      console.log("STATUS =>", error.response?.status);
      console.log("FULL ERROR =>", error);
    }
  };

  if (!product) {
    return <div>Loading...</div>;
  }

  return (
    <div className="bg-white p-6 rounded-xl shadow">
      <h2 className="text-3xl font-bold mb-5">Edit Product</h2>

      <ProductForm
        initialData={product}
        onSubmit={updateProduct}
        buttonText="Update Product"
      />
    </div>
  );
}

export default EditProductPage;
